import { render } from "./LastView.vue?vue&type=template&id=3a64e12c&scoped=true&ts=true"
import script from "./LastView.vue?vue&type=script&lang=ts"
export * from "./LastView.vue?vue&type=script&lang=ts"

import "./LastView.vue?vue&type=style&index=0&id=3a64e12c&scoped=true&lang=scss"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a64e12c"]])

export default __exports__